export default __webpack_public_path__ + "static/media/3981d96d-9c10-4cd8-a0d5-87d9dbd3ff29.690a5410.JPG";